<script setup>
import { defineProps, defineEmits } from "vue";
import {useI18n} from "vue-i18n";
const { t } = useI18n();
const props = defineProps({
    modelValue: { type: Boolean, default: false },
    item: { type: String, default: null },
});

const emit = defineEmits(["update:modelValue", "confirm"]);

const close = () => emit("update:modelValue", false);
const confirm = () => emit("confirm");
</script>

<template>
    <v-dialog v-model="props.modelValue" max-width="500">
        <v-card class="bg-white trezo-form-group">
            <v-card-title class="fw-medium text-black">
                {{ t('common.labels.deleteConfirmation')}}
            </v-card-title>

            <v-card-text>
                <slot>
                    {{ t("common.labels.confirmDeleteMessage") }}
                    <strong v-if="props.item">{{ props.item }}</strong>?
                </slot>
            </v-card-text>

            <v-card-actions>
                <v-btn text @click="close">{{ t("common.labels.cancel") }}</v-btn>
                <v-btn class="text-danger" @click="confirm">{{ t("common.labels.delete") }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
